export type PricingPageLocale = 'de' | 'en-GB' | 'en-US' | 'fr-FR';

export type PricingPageForMiddleware = {
  id: number;
  campaign: string | null;
  startingAtDay: string | null;
  startingAtHour: string | null;
  endingAtDay: string | null;
  endingAtHour: string | null;
  locale: PricingPageLocale;
  maxTrialDuration: number | null;
  hasSwissVersion: boolean;
};

export const findCampaignTrialDays = (campaign: string) => {
  const pricingPage = pricingPages.find((page) => page.campaign === campaign);

  if (pricingPage && pricingPage.maxTrialDuration) {
    return pricingPage.maxTrialDuration;
  }

  return undefined;
};

export const pricingPages: PricingPageForMiddleware[] = [
  {
    id: 9,
    campaign: '30daytrial',
    startingAtDay: null,
    startingAtHour: null,
    endingAtDay: null,
    endingAtHour: null,
    locale: 'de',
    maxTrialDuration: 30,
    hasSwissVersion: true,
  },
  {
    id: 8,
    campaign: 'b2b_30_days',
    startingAtDay: null,
    startingAtHour: null,
    endingAtDay: null,
    endingAtHour: null,
    locale: 'de',
    maxTrialDuration: 30,
    hasSwissVersion: false,
  },
  {
    id: 14,
    campaign: 'espace-plaisir',
    startingAtDay: null,
    startingAtHour: null,
    endingAtDay: null,
    endingAtHour: null,
    locale: 'fr-FR',
    maxTrialDuration: 30,
    hasSwissVersion: true,
  },
  {
    id: 36,
    campaign: '14-day-trial-fr',
    startingAtDay: null,
    startingAtHour: null,
    endingAtDay: null,
    endingAtHour: null,
    locale: 'fr-FR',
    maxTrialDuration: 14,
    hasSwissVersion: true,
  },
  {
    id: 38,
    campaign: 'gratis-mai',
    startingAtDay: null,
    startingAtHour: null,
    endingAtDay: null,
    endingAtHour: null,
    locale: 'de',
    maxTrialDuration: 30,
    hasSwissVersion: true,
  },
  {
    id: 15,
    campaign: '30_day_trial',
    startingAtDay: '2023-11-01',
    startingAtHour: null,
    endingAtDay: null,
    endingAtHour: null,
    locale: 'de',
    maxTrialDuration: 30,
    hasSwissVersion: true,
  },
  {
    id: 20,
    campaign: 'black-friday-de-25',
    startingAtDay: '2023-11-22',
    startingAtHour: '16:00:00',
    endingAtDay: '2023-11-28',
    endingAtHour: '00:30:00',
    locale: 'de',
    maxTrialDuration: 14,
    hasSwissVersion: true,
  },
  {
    id: 1,
    campaign: null,
    startingAtDay: null,
    startingAtHour: null,
    endingAtDay: null,
    endingAtHour: null,
    locale: 'de',
    maxTrialDuration: 14,
    hasSwissVersion: true,
  },
  {
    id: 26,
    campaign: null,
    startingAtDay: null,
    startingAtHour: null,
    endingAtDay: null,
    endingAtHour: null,
    locale: 'de',
    maxTrialDuration: 14,
    hasSwissVersion: true,
  },
  {
    id: 27,
    campaign: null,
    startingAtDay: null,
    startingAtHour: null,
    endingAtDay: null,
    endingAtHour: null,
    locale: 'de',
    maxTrialDuration: 14,
    hasSwissVersion: true,
  },
  {
    id: 28,
    campaign: null,
    startingAtDay: null,
    startingAtHour: null,
    endingAtDay: null,
    endingAtHour: null,
    locale: 'fr-FR',
    maxTrialDuration: 14,
    hasSwissVersion: true,
  },
  {
    id: 29,
    campaign: null,
    startingAtDay: null,
    startingAtHour: null,
    endingAtDay: null,
    endingAtHour: null,
    locale: 'fr-FR',
    maxTrialDuration: 14,
    hasSwissVersion: true,
  },
  {
    id: 5,
    campaign: 'Churner_1_year',
    startingAtDay: null,
    startingAtHour: null,
    endingAtDay: null,
    endingAtHour: null,
    locale: 'de',
    maxTrialDuration: null,
    hasSwissVersion: false,
  },
  {
    id: 6,
    campaign: 'Churner_3_months',
    startingAtDay: null,
    startingAtHour: null,
    endingAtDay: null,
    endingAtHour: null,
    locale: 'de',
    maxTrialDuration: null,
    hasSwissVersion: false,
  },
  {
    id: 7,
    campaign: 'Churner_6_months',
    startingAtDay: null,
    startingAtHour: null,
    endingAtDay: null,
    endingAtHour: null,
    locale: 'de',
    maxTrialDuration: null,
    hasSwissVersion: false,
  },
  {
    id: 11,
    campaign: 'espace-plaisir',
    startingAtDay: null,
    startingAtHour: null,
    endingAtDay: null,
    endingAtHour: null,
    locale: 'de',
    maxTrialDuration: 30,
    hasSwissVersion: true,
  },
  {
    id: 30,
    campaign: '50-sparen-de',
    startingAtDay: null,
    startingAtHour: null,
    endingAtDay: null,
    endingAtHour: null,
    locale: 'de',
    maxTrialDuration: null,
    hasSwissVersion: true,
  },
  {
    id: 12,
    campaign: 'espace-plaisir',
    startingAtDay: null,
    startingAtHour: null,
    endingAtDay: null,
    endingAtHour: null,
    locale: 'en-GB',
    maxTrialDuration: 30,
    hasSwissVersion: false,
  },
  {
    id: 13,
    campaign: 'espace-plaisir',
    startingAtDay: null,
    startingAtHour: null,
    endingAtDay: null,
    endingAtHour: null,
    locale: 'en-US',
    maxTrialDuration: 30,
    hasSwissVersion: false,
  },
  {
    id: 10,
    campaign: 'ohhhmhhh',
    startingAtDay: null,
    startingAtHour: null,
    endingAtDay: null,
    endingAtHour: null,
    locale: 'de',
    maxTrialDuration: 30,
    hasSwissVersion: true,
  },
  {
    id: 31,
    campaign: 'economisez-50-fr',
    startingAtDay: null,
    startingAtHour: null,
    endingAtDay: null,
    endingAtHour: null,
    locale: 'fr-FR',
    maxTrialDuration: null,
    hasSwissVersion: false,
  },
  {
    id: 19,
    campaign: null,
    startingAtDay: null,
    startingAtHour: null,
    endingAtDay: null,
    endingAtHour: null,
    locale: 'de',
    maxTrialDuration: null,
    hasSwissVersion: false,
  },
  {
    id: 4,
    campaign: null,
    startingAtDay: null,
    startingAtHour: null,
    endingAtDay: null,
    endingAtHour: null,
    locale: 'fr-FR',
    maxTrialDuration: 14,
    hasSwissVersion: true,
  },
  {
    id: 39,
    campaign: 'gratuit-mai',
    startingAtDay: null,
    startingAtHour: null,
    endingAtDay: null,
    endingAtHour: null,
    locale: 'fr-FR',
    maxTrialDuration: 30,
    hasSwissVersion: true,
  },
  {
    id: 23,
    campaign: 'economisez-45-fr',
    startingAtDay: null,
    startingAtHour: null,
    endingAtDay: null,
    endingAtHour: null,
    locale: 'fr-FR',
    maxTrialDuration: null,
    hasSwissVersion: true,
  },
  {
    id: 22,
    campaign: '40-sparen-de',
    startingAtDay: null,
    startingAtHour: null,
    endingAtDay: null,
    endingAtHour: null,
    locale: 'de',
    maxTrialDuration: null,
    hasSwissVersion: true,
  },
  {
    id: 17,
    campaign: '30_day_trial',
    startingAtDay: null,
    startingAtHour: null,
    endingAtDay: null,
    endingAtHour: null,
    locale: 'en-GB',
    maxTrialDuration: 30,
    hasSwissVersion: false,
  },
  {
    id: 16,
    campaign: '30_day_trial',
    startingAtDay: null,
    startingAtHour: null,
    endingAtDay: null,
    endingAtHour: null,
    locale: 'fr-FR',
    maxTrialDuration: 30,
    hasSwissVersion: true,
  },
  {
    id: 18,
    campaign: '30_day_trial',
    startingAtDay: null,
    startingAtHour: null,
    endingAtDay: null,
    endingAtHour: null,
    locale: 'en-US',
    maxTrialDuration: 30,
    hasSwissVersion: false,
  },
  {
    id: 21,
    campaign: 'black-friday-fr-25',
    startingAtDay: '2023-11-22',
    startingAtHour: '16:00:00',
    endingAtDay: '2023-11-28',
    endingAtHour: '00:30:00',
    locale: 'fr-FR',
    maxTrialDuration: 14,
    hasSwissVersion: true,
  },
  {
    id: 2,
    campaign: null,
    startingAtDay: null,
    startingAtHour: null,
    endingAtDay: null,
    endingAtHour: null,
    locale: 'en-GB',
    maxTrialDuration: 14,
    hasSwissVersion: false,
  },
  {
    id: 3,
    campaign: null,
    startingAtDay: null,
    startingAtHour: null,
    endingAtDay: null,
    endingAtHour: null,
    locale: 'en-US',
    maxTrialDuration: 14,
    hasSwissVersion: false,
  },
  {
    id: 24,
    campaign: '24-tage-xmas-de',
    startingAtDay: '2023-11-29',
    startingAtHour: null,
    endingAtDay: '2023-12-31',
    endingAtHour: null,
    locale: 'de',
    maxTrialDuration: 24,
    hasSwissVersion: true,
  },
  {
    id: 25,
    campaign: 'essay-24-jour',
    startingAtDay: '2023-11-29',
    startingAtHour: null,
    endingAtDay: '2023-12-31',
    endingAtHour: null,
    locale: 'fr-FR',
    maxTrialDuration: 24,
    hasSwissVersion: true,
  },
  {
    id: 34,
    campaign: 'economisez-30-fr',
    startingAtDay: null,
    startingAtHour: null,
    endingAtDay: null,
    endingAtHour: null,
    locale: 'fr-FR',
    maxTrialDuration: null,
    hasSwissVersion: false,
  },
  {
    id: 33,
    campaign: '30-sparen-de',
    startingAtDay: null,
    startingAtHour: null,
    endingAtDay: null,
    endingAtHour: null,
    locale: 'de',
    maxTrialDuration: null,
    hasSwissVersion: true,
  },
  {
    id: 35,
    campaign: '14-day-trial',
    startingAtDay: null,
    startingAtHour: null,
    endingAtDay: null,
    endingAtHour: null,
    locale: 'de',
    maxTrialDuration: 14,
    hasSwissVersion: true,
  },
  {
    id: 37,
    campaign: '30_day_trial_product_test',
    startingAtDay: null,
    startingAtHour: null,
    endingAtDay: null,
    endingAtHour: null,
    locale: 'de',
    maxTrialDuration: 30,
    hasSwissVersion: true,
  },
];
